// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:y8TaIP */\n.m90FS:not(:disabled) svg{color:var(--audio-status-success)}.aCCfW{align-items:center;color:inherit;display:flex;font-size:var(--audio-font-size-17);font-weight:600;gap:var(--audio-spacing-8);line-height:var(--audio-line-height-24);text-transform:uppercase}.dsca1{height:2rem;width:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"liked": "m90FS",
	"plain": "aCCfW",
	"plainIcon": "dsca1"
};
export default ___CSS_LOADER_EXPORT___;
